import {Pill} from '@wandb/weave/components/Tag';
import React from 'react';

export type SecretPool = 'personal' | 'team';

const SECRET_POOL_PILL = {
  personal: {label: 'Personal', icon: 'user-profile-personal', color: 'purple'},
  team: {label: 'Team', icon: 'users-team', color: 'blue'},
} as const;

export const SecretPoolPill = ({pool}: {pool: SecretPool}) => {
  const {label, icon, color} = SECRET_POOL_PILL[pool];
  return <Pill label={label} icon={icon} color={color} />;
};
